import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginTenantLinksContainerModel } from "../../../../../models";
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class LoginTenantLinksService extends BaseApiTemplateService<LoginTenantLinksContainerModel> {
    constructor(http: HttpClient){
        super();
        this.httpClient = http;
    }

    private setUrl(endpoint: string){
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `login-tenant-links/${endpoint}` ;
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `login-tenant-links/${endpoint}`;
    }

    sysadminPost(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.post(dtoObject, apiVisa)
    }

    sysadminDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.delete(guid, apiVisa);
    }

    sysadminPut(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.put(dtoObject, apiVisa);
    }

    sysadminGetAll(apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.get(apiVisa);
    }

    sysadminGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.getByGuid(guid, apiVisa);
    }

    sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep');
        return super.getByCriteria(pagination, apiVisa);
    }

    tenantAdminEpPut(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('admin/tenant-admin-ep');
        return super.put(dtoObject, apiVisa);
    }
}